const SRT_TIMESTAMP = /(\d{1,2}:)?(\d{2}:\d{2}),(\d{3})/g;

/**
 * Converts SubRip text to WebVTT, the only subtitle format a <track> element accepts.
 * WebVTT already allows the numeric cue identifiers SubRip uses, so only the header and
 * the millisecond separator need to change. Text that is already WebVTT passes through.
 */
export function srtToVtt(input: string): string {
  const body = input.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n').trim();
  if (body.startsWith('WEBVTT')) {
    return `${body}\n`;
  }
  return `WEBVTT\n\n${body.replace(SRT_TIMESTAMP, '$1$2.$3')}\n`;
}
